export function topbarelementRender() { return `${ this.prop.type === 'Title' ? `<div class="top-bar-item title" style="${  this.__$objToStyleMap(this.topBarTitleStyle)  }" ld--elist="click" ld-on-click="onItemClick">
    <div class="main-title"><span>${ this.mainTitle }</span></div>
    ${ this.subText ? `<div class="sub-title"><span>${ this.subText }</span></div>`:`` }
</div>`
:`<div>
    ${ this.prop.type === 'Status' ? `<div class="top-bar-item status" style="${  this.__$objToStyleMap(this.topBarStatusStyle)  }" ld--elist="click" ld-on-click="onItemClick">
        ${ this.status ? `<div class="main-status"><span>${ this.status }</span></div>`:`` }
        ${ this.subStatus ? `<div class="sub-status"><span>${ this.subStatus }</span></div>`:`` }
    </div>`
    :`<div>
        ${ this.prop.type === 'Description' ? `<div class="top-bar-item description" style="${  this.__$objToStyleMap(this.topBarDescriptionStyle)  }" ld--elist="click" ld-on-click="onItemClick">
            <span>${ this.prop.text }</span>
        </div>`:`` }
        ${ this.prop.extended ? `<button class="extended-topbar-button" aria-label="${this.text}" ld--elist="click" ld-on-click="onItemClick">
            <span class="extended-item icon" style="${  this.__$objToStyleMap(this.extendedIconStyle)  }">
            </span>
            <span class="extended-text"> ${ this.text } </span>
        </button>`
        :`<div>
            ${ this.prop.type === 'Logo' ? `<div class="top-bar-item logo" role="img" ${ this.text != "" ? `aria-label="${ this.text }"` : `alt="" aria-hidden= "true"` } style="${  this.__$objToStyleMap(this.topBarLogoStyle)  }"></div>`
            :`<div class="top-bar-item icon" style="${  this.__$objToStyleMap(this.topBarIconStyle)  }" aria-label="${ this.text }" role="button" tabindex="0" ld--elist="touchend,click" ld-on-touchend="onIconClick" ld-on-click="onIconClick">
            </div>` }
        </div>` }
    </div>` }
</div>` }`  }